import { Controller } from "@hotwired/stimulus"
import { isLogoutRequest, sessionDrafts } from "../studio/draft_store"

document.addEventListener("turbo:before-fetch-request", event => {
  if (isLogoutRequest(event.detail.url)) sessionDrafts().clear()
})

export default class extends Controller {
  static targets = ["input"]
  static values = { draftKey: String }

  connect() {
    this.drafts = sessionDrafts()
    const field = this.element.querySelector('[name="turn[input_question_id]"]')?.value || ""
    this.key = `${this.draftKeyValue}/${field}`
    const saved = this.drafts.read(this.key)
    if (!saved || !this.hasInputTarget || this.inputTarget.value) return
    this.inputTarget.value = saved.text
    this.choices.forEach(choice => { choice.checked = saved.choices.includes(choice.value) })
  }

  save() {
    if (!this.hasInputTarget) return
    this.drafts.write(this.key, {
      text: this.inputTarget.value,
      choices: this.choices.filter(choice => choice.checked).map(choice => choice.value)
    })
  }

  submitted(event) {
    if (event.detail.success) this.drafts.remove(this.key)
  }

  get choices() {
    return Array.from(this.element.querySelectorAll('[name="turn[selected_option_ids][]"]'))
  }
}
